import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import {
  MEDICATION_SCHEDULE_PATTERN_QUERY_KEY,
  MEDICATION_SCHEDULE_PATTERN_UNPAUSE_URL
} from './queryConstants'
import { useInvalidateMedicationQueries } from './useInvalidateMedicationQueries'

type UseMedicationSchedulePatternUnpauseReturn = {
  unpauseMedicationSchedulePattern: (reason: string) => Promise<void>
  isUnpausingMedicationSchedulePattern: boolean
}

export type UseMedicationSchedulePatternUnpauseProps = {
  medicationId: string
  onSuccess?: () => void
  onError?: () => void
}

const useMedicationSchedulePatternUnpause = ({
  medicationId,
  onSuccess,
  onError
}: UseMedicationSchedulePatternUnpauseProps): UseMedicationSchedulePatternUnpauseReturn => {
  const invalidateMedicationQueries = useInvalidateMedicationQueries()

  const unpauseMedicationSchedulePatternFunction = async (
    reason: string
  ): Promise<unknown> => {
    return postJSON({
      url: MEDICATION_SCHEDULE_PATTERN_UNPAUSE_URL.replace(
        '{id}',
        medicationId
      ),
      method: 'PUT',
      json: {
        reason
      }
    })
  }

  const {
    mutateAsync: unpauseMedicationSchedulePatternMutation,
    isLoading: isUnpausingMedicationSchedulePattern
  } = useMutation<unknown, unknown, string, unknown>(
    [MEDICATION_SCHEDULE_PATTERN_QUERY_KEY],
    unpauseMedicationSchedulePatternFunction,
    {
      onSuccess: () => {
        invalidateMedicationQueries()
        onSuccess?.()
      },
      onError: () => {
        onError?.()
      }
    }
  )

  const unpauseMedicationSchedulePattern = async (
    reason: string
  ): Promise<void> => {
    await unpauseMedicationSchedulePatternMutation(reason)
  }

  return {
    unpauseMedicationSchedulePattern,
    isUnpausingMedicationSchedulePattern
  }
}

export default useMedicationSchedulePatternUnpause
